document.addEventListener('DOMContentLoaded', function() {
  const nav = document.getElementById('CustomMobileNav');
  if (!nav) return;

  const originalMenuTrigger = document.querySelector('.burger-js');
  if (originalMenuTrigger) {
    // FIX: Instead of cloning, we just add the listener.
    // Ensure we don't add multiple listeners if this script runs again.
    if (!originalMenuTrigger.dataset.navInited) {
      originalMenuTrigger.dataset.navInited = 'true';
      originalMenuTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openNav();
      });
    }
  }

  let navigationHistory = [];
  let currentMenuHandle = 'mobile-nav-women';

  const closeBtn = nav.querySelector('.custom-mobile-nav__close-btn');
  const backBtn = nav.querySelector('.custom-mobile-nav__back-btn');
  const navTitle = nav.querySelector('.custom-mobile-nav__title');
  const headerLogo = nav.querySelector('.custom-mobile-nav__header-logo');
  const tabs = nav.querySelectorAll('.custom-mobile-nav__tab-btn');
  const allPanels = nav.querySelectorAll('.custom-mobile-nav__panel');
  const level1 = nav.querySelector('[data-level="1"]');
  const level2 = nav.querySelector('[data-level="2"]');
  const level2Content = nav.querySelector('.custom-mobile-nav__submenu-content');

  // Cache panels for faster lookups
  const panelsMap = {};
  allPanels.forEach(p => {
    const handle = p.dataset.menuHandle;
    if (handle) panelsMap[handle] = p;
  });

  function openNav() {
    showMainTabs();
    requestAnimationFrame(() => {
      nav.classList.add('is-open');
      document.body.classList.add('custom-nav-open');
    });
  }

  function closeNav() {
    nav.classList.add('is-closing');
    nav.classList.remove('is-open');

    setTimeout(() => {
      nav.classList.remove('is-closing');
      document.body.classList.remove('custom-nav-open');
    }, 300);
  }

  function showMainTabs() {
    navigationHistory = [];
    level1.style.display = 'block';
    
    requestAnimationFrame(() => {
      level1.style.opacity = '1';
      level1.style.pointerEvents = 'auto';
      level1.style.height = 'auto';
      level1.style.overflow = 'visible';

      level2.style.display = 'none';
      if (backBtn) backBtn.style.display = 'none';
      if (navTitle) {
        navTitle.textContent = '';
        navTitle.style.cursor = 'default';
        navTitle.dataset.url = '';
      }

      if (headerLogo) headerLogo.style.display = 'block';
    });
  }

  function renderLevel(content, title, url) {
    level2Content.innerHTML = '';
    const clone = content.cloneNode(true);
    clone.style.display = 'block';
    level2Content.appendChild(clone);

    if (navTitle) {
      navTitle.textContent = title || '';
      navTitle.style.cursor = url ? 'pointer' : 'default';
      navTitle.dataset.url = url || '';
    }

    requestAnimationFrame(() => {
      level1.style.opacity = '0';
      level1.style.pointerEvents = 'none';
      level1.style.height = '0';
      level1.style.overflow = 'hidden';
      
      level2.style.display = 'block';
      if (backBtn) backBtn.style.display = 'block';

      if (headerLogo) headerLogo.style.display = 'none';
      
      const scroller = nav.querySelector('.custom-mobile-nav__scroller');
      if (scroller) scroller.scrollTop = 0;
    });
  }

  function goBack() {
    showMainTabs();
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeNav();
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', goBack);
  }

  if (navTitle) {
    navTitle.addEventListener('click', () => {
      if (navTitle.dataset.url) window.location.href = navTitle.dataset.url;
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const handle = tab.dataset.menuHandle;
      if (!handle || handle === currentMenuHandle) return;

      requestAnimationFrame(() => {
        // Deactivate previous
        const prevPanel = panelsMap[currentMenuHandle];
        const prevTab = nav.querySelector(`.custom-mobile-nav__tab-btn.active`);
        if (prevPanel) prevPanel.classList.remove('active');
        if (prevTab) prevTab.classList.remove('active');

        // Activate current
        const nextPanel = panelsMap[handle];
        if (nextPanel) nextPanel.classList.add('active');
        tab.classList.add('active');

        currentMenuHandle = handle;
        
        const scroller = nav.querySelector('.custom-mobile-nav__scroller');
        if (scroller) scroller.scrollTop = 0;
      });
    });
  });

  nav.addEventListener('click', (e) => {
    const targetLink = e.target.closest('a[data-has-submenu="true"]');
    if (!targetLink) return;

    e.preventDefault();
    const submenuContainer = targetLink.nextElementSibling;

    if (submenuContainer && submenuContainer.classList.contains('custom-mobile-nav__submenu-data')) {
      const title = targetLink.dataset.title || targetLink.textContent.trim();
      const url = targetLink.href;
      renderLevel(submenuContainer, title, url);
    }
  });

  // Default selection - directly activate first tab without relying on click
  // (click handler returns early if handle === currentMenuHandle)
  if (tabs.length > 0 && !nav.querySelector('.custom-mobile-nav__tab-btn.active')) {
    const firstTab = tabs[0];
    const firstHandle = firstTab.dataset.menuHandle;
    const firstPanel = panelsMap[firstHandle];
    
    if (firstPanel) {
      firstPanel.classList.add('active');
      firstTab.classList.add('active');
      currentMenuHandle = firstHandle;
    }
  }
});